<script setup lang="ts">
import MedicationCheckupCopiloteLine from "@/medication-checkup/components/MedicationCheckupCopiloteLine.vue";
import MedicationCheckupUserEcho from "@/medication-checkup/components/MedicationCheckupUserEcho.vue";
import MedicationCheckupCopiloteBubble from "@/medication-checkup/components/MedicationCheckupCopiloteBubble.vue";
import MedicationCheckupSceneReplies from "@/medication-checkup/components/MedicationCheckupSceneReplies.vue";
import MedicationCheckupNextAppointmentCard from "@/medication-checkup/components/MedicationCheckupNextAppointmentCard.vue";
import {NextAppointmentView} from "@/medication-checkup/interfaces/next-appointment";
import {SceneProps} from "@/medication-checkup/composables/useScene";
import {useNextAppointmentScene} from "@/medication-checkup/composables/useNextAppointmentScene";

/**
 * The scene of the appointment of the adherence follow-up, set at the end of
 * the advice interview as its form asks.
 *
 * The card shows the appointment the agenda holds for that step and stays
 * live once the block is completed; everything shown is served by the
 * handler of the block.
 */

const props = defineProps<SceneProps<NextAppointmentView>>();

const {bubbleShown, cardShown, clicked, view, text, actions, acted, act} = useNextAppointmentScene(props);
</script>

<template>
  <div class="flex flex-col gap-3.5">
    <template v-if="frozen">
      <MedicationCheckupCopiloteLine v-if="text" :text="text" />
      <MedicationCheckupNextAppointmentCard v-if="view" :view="view" />
      <MedicationCheckupUserEcho v-if="acted" :text="acted" />
    </template>

    <template v-else>
      <MedicationCheckupCopiloteBubble
        :shown="bubbleShown"
        :text="text"
      />

      <MedicationCheckupNextAppointmentCard
        v-if="cardShown && view"
        :view="view"
        class="animate-message-in"
      />

      <MedicationCheckupSceneReplies
        :clicked="clicked"
        :actions="actions"
        :shown="cardShown"
        @act="act"
      />
    </template>
  </div>
</template>
